import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import MainLayout from 'views/components/layout/MainLayout';
import Loadable from 'views/components/ui-component/Loadable';
import DeviceRegister from '../views/pages/management/license/DeviceRegister';
import DeviceDetail from '../views/pages/management/license/DeviceDetail';
import DeviceEdit from '../views/pages/management/license/DeviceEdit';

// lazy load all components
const ExamService = Loadable(lazy(() => import('views/pages/service/exam')));
const ExamRegister = Loadable(lazy(() => import('views/pages/service/exam/ExamRegister')));
const UserInfo = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserInfo')));
const ExamDetail = Loadable(lazy(() => import('views/pages/service/exam/ExamDetail')));
const UserEdit = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserEdit')));
const UserPasswordChange = Loadable(lazy(() => import('views/pages/management/user/UserPasswordChange')));
const User = Loadable(lazy(() => import('views/pages/management/user')));
const UserRegister = Loadable(lazy(() => import('views/pages/management/user/UserRegister')));
const UserDetail = Loadable(lazy(() => import('views/pages/management/user/UserDetail')));
const UserInfoEdit = Loadable(lazy(() => import('views/pages/management/user/UserEdit')));
const UserPasswordReset = Loadable(lazy(() => import('views/pages/management/user/UserPasswordReset')));

// ==============================|| MANAGER ROUTES ||============================== //

const DepartmentManagerRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="/service/exam/all" replace />
        },
        {
            path: 'service',
            children: [
                {
                    path: 'exam',
                    children: [
                        {
                            path: ':status/:id',
                            element: <ExamDetail />
                        },
                        {
                            path: 'register',
                            element: <ExamRegister />
                        },
                        {
                            path: 'all',
                            element: <ExamService />
                        },
                        {
                            path: '',
                            element: <ExamService />
                        },
                        {
                            path: '*',
                            element: <ExamService />
                        }
                    ]
                }
            ]
        },
        {
            path: 'management',
            children: [
                {
                    path: 'user',
                    children: [
                        {
                            path: '',
                            element: <User />
                        },
                        {
                            path: 'register',
                            element: <UserRegister />
                        },
                        {
                            path: ':id',
                            element: <UserDetail />
                        },
                        {
                            path: ':id/edit',
                            element: <UserInfoEdit />
                        },
                        {
                            path: ':id/password/reset',
                            element: <UserPasswordReset />
                        }
                    ]
                }
            ]
        },
        {
            path: 'auth',
            children: [
                {
                    path: 'me',
                    element: <UserInfo />
                },
                {
                    path: 'me/edit',
                    element: <UserEdit />
                },
                {
                    path: 'password/change',
                    element: <UserPasswordChange />
                }
            ]
        },
        {
            path: '*',
            element: <Navigate to="/service/exam/all" replace />
        }
    ]
};

export default DepartmentManagerRoutes;
